(function () {
  const THRESHOLD = 600;

  const state = {
    widget: null,
    button: null,
    queued: false,
    visible: false,
    forceHidden: false,
    initialized: false,
  };

  function isEnabled() {
    if (!window.backToTopSettings || typeof window.backToTopSettings.enabled === 'undefined') {
      return true;
    }

    return Boolean(window.backToTopSettings.enabled);
  }

  function createWidget() {
    if (state.widget) return state.widget;

    const widget = document.createElement('div');
    widget.className = 'back-to-top';
    widget.setAttribute('aria-hidden', 'true');
    widget.innerHTML = `
      <button type="button" class="back-to-top__button" aria-label="Back to top">
        <span class="visually-hidden">Back to top</span>
        <span aria-hidden="true" class="back-to-top__button-face">
          <svg class="back-to-top__icon" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <path d="M12 19V5"></path>
            <path d="M6.5 10.5L12 5l5.5 5.5"></path>
          </svg>
        </span>
      </button>
    `;

    document.body.appendChild(widget);

    const button = widget.querySelector('.back-to-top__button');

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      state.forceHidden = true;
      hideWidget();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    });

    button.addEventListener('pointerdown', () => {
      button.classList.add('is-pressed');
    });

    button.addEventListener('pointerup', () => {
      button.classList.remove('is-pressed');
    });

    button.addEventListener('pointercancel', () => {
      button.classList.remove('is-pressed');
    });

    button.addEventListener('mouseleave', () => {
      button.classList.remove('is-pressed');
    });

    state.widget = widget;
    state.button = button;
    return widget;
  }

  function hideWidget() {
    if (!state.widget) return;

    state.visible = false;
    state.widget.classList.remove('is-visible');
    state.widget.setAttribute('aria-hidden', 'true');
    if (state.button) {
      state.button.setAttribute('aria-expanded', 'false');
    }
  }

  function updateVisibility() {
    state.queued = false;

    if (!isEnabled() || !document.body) {
      hideWidget();
      return;
    }

    if (!state.widget) createWidget();
    if (!state.widget) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (state.forceHidden) {
      if (scrollY > 1000) {
        state.forceHidden = false;
      } else {
        hideWidget();
        return;
      }
    }

    const shouldShow = scrollY > THRESHOLD;

    if (shouldShow === state.visible) {
      return;
    }

    state.visible = shouldShow;
    state.widget.classList.toggle('is-visible', shouldShow);
    state.widget.setAttribute('aria-hidden', String(!shouldShow));
    if (state.button) {
      state.button.setAttribute('aria-expanded', String(shouldShow));
    }
  }

  function queueUpdate() {
    if (state.queued) return;
    state.queued = true;

    window.requestAnimationFrame(updateVisibility);
  }

  function init() {
    if (state.initialized) return;
    state.initialized = true;

    if (!document.body || !isEnabled()) {
      return;
    }

    createWidget();
    updateVisibility();

    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate, { passive: true });
    window.addEventListener('orientationchange', queueUpdate, { passive: true });
    window.addEventListener('pageshow', queueUpdate);
    document.addEventListener('DOMContentLoaded', queueUpdate);
    document.addEventListener('shopify:section:load', queueUpdate);
    document.addEventListener('shopify:section:reorder', queueUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
